module.exports = __webpack_public_path__ + "img/indoor.dacac79c.svg";